import { useRewardTierApplied } from '@fhs/loyalty/src/hooks/use-reward-tier-applied';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';

/**
 * Consumes cart price order state only. Does not trigger tryPricing.
 * Pricing is triggered once by the cart context when cart/offers change.
 */
export function useCartPriceOrder() {
  const { rewardTierApplied } = useRewardTierApplied();
  const isRewardApplied = !!rewardTierApplied;
  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const incentiveApplied = isRewardApplied || selectedOffer;

  const { serverOrder, serverOrderLoading } = useCartContext();

  return {
    serverOrder,
    serverOrderLoading,
    serverOrderTotal: serverOrder?.cart?.subTotalCents,
    incentiveApplied,
  };
}
